/**
 * Product keys for third-party connectors.
 * Each key maps to a unique identifier used throughout the search system.
 */
export const ProductKeys3P = {
	AtlassianWebCrawler: 'atlassian-web-crawler',
	Figma: 'figma',
	Github: 'github',
	GoogleDrive: 'drive',
	Loom: 'loom',
	OneDrive: 'onedrive',
	Dropbox: 'dropbox',
	Slack: 'slack',
	Sharepoint: 'sharepoint',
	Teams: 'teams',
	GoogleCalendar: 'google-calendar',
	OutlookCalendar: 'outlook-calendar',
	OutlookMail: 'outlook-mail',
	Gmail: 'gmail',
	AdobeSign: 'adobe-sign',
	Asana: 'asana',
	Zendesk: 'zendesk',
	Airtable: 'airtable',
	Smartsheet: 'smartsheet',
	Notion: 'notion',
	Miro: 'miro',
	Docusign: 'docusign',
	Lucid: 'lucid',
	Monday: 'monday',
	AzureDevops: 'azure-devops',
	Gitlab: 'gitlab',
	ConfluenceDC: 'confluence-dc',
	Canva: 'canva',
	Box: 'box',
	Zeplin: 'zeplin',
	ServiceNow: 'servicenow',
	Freshservice: 'freshservice',
	PowerBI: 'power-bi',
	ClickUp: 'clickup',
	Amplitude: 'amplitude',
	Stripe: 'stripe',
	AdobeXD: 'adobexd',
	Aha: 'aha',
	Mural: 'mural',
	Webex: 'webex',
	Todoist: 'todoist',
	PagerDuty: 'pagerduty',
	Pipedrive: 'pipedrive',
	Hubspot: 'hubspot',
	Dovetail: 'dovetail',
	LaunchDarkly: 'launchdarkly',
	Salesforce: 'salesforce',
	Sentry: 'sentry',
	JiraDC: 'jira-dc',
	Gitbook: 'gitbook',
	AWSS3: 'aws-s3',
	Databricks: 'databricks',
	JsmDC: 'jsm-dc',
	ForgeAdamVitareqDev: 'forge-connector-dAkghOClvWGokDftTTaIgNoD6pnNt74z-vitareq-connector',
	ForgeAdamVitareqProd: 'forge-connector-EjfoGWrWrETl3Zc5zkGynPyESZO5Qu93-vitareq-connector',
	ForgeK15tScrollSitesDev:
		'forge-connector-h1n3NRFAn84v7ECSONVidlCS88qZh8cy-scroll-sites-connector',
	ForgeK15tScrollSitesProd:
		'forge-connector-ofe9zXccOCQ3U4t4kDVywSyJUoZjb1sO-scroll-sites-connector',
	ForgePioAwsDev: 'forge-connector-HaxJprV0zzjjvwLhGkAN2gDPhHZwXNiL-s3-connector',
	ForgePioAwsProd: 'forge-connector-mRcqWRwqkUd4JwapGkvGHUViyySX9MVy-s3-connector',
	ForgePioClickupDev: 'forge-connector-ELuz3hTMhig0Jdrr6ytI45SifO9DfKrY-clickup-connector',
	ForgePioClickupProd: 'forge-connector-uwYqtNjM6w0QIhHOFG0Cq4cnkUM9mt3K-clickup-connector',
	ForgePioGitbookDev: 'forge-connector-Xh70v2yqkzOjTQqTMLxk1lElehWIXoYi-gitbook-connector',
	ForgePioGitbookProd: 'forge-connector-cQ1IDSmJT0DrQuF8pGa4ijz0XZ6IGF5u-gitbook-connector',
	ForgePioGithubDev: 'forge-connector-3QYYBgeNDilQB3Jc7uGMCchNgUGvCi7j-github-connector',
	ForgePioGithubProd: 'forge-connector-0Sw5Yr860fgfx5sYS7kEUoxnGhEvrhhI-github-connector',
	ForgePioGitlabDev: 'forge-connector-psr1wBkasRuKCwsvwi4aTJNhjmlVFebC-gitlab-connector',
	ForgePioGitlabProd: 'forge-connector-QLK5Xf8nBqejSZTulw5s3Cl6fIS24MwL-gitlab-connector',
	ForgePioGoogleDriveDev: 'forge-connector-JhqjCcAP6AHHxkYhY2akTgZsYXY93SMq-google-drive-connector',
	ForgePioGoogleDriveProd:
		'forge-connector-pcIwW04B398CSnilRIyzPJ5v5GevlCCo-google-drive-connector',
	ForgePioGuruDev: 'forge-connector-NtY3W5Z8JTBshAgPZFIfT7VjYAARj1P5-guru-connector',
	ForgePioGuruProd: 'forge-connector-mulxOVrXWOZObhFZH5WAqs7Ga2lCPK29-guru-connector',
	ForgePioHelpjuiceDev: 'forge-connector-f1rvRuAyoDWIwDs7Xubi5AZJTuESM5PC-helpjuice-connector',
	ForgePioHelpjuiceProd: 'forge-connector-8durapLyclxZeEexKkwxw6ZpCRpBz4dP-helpjuice-connector',
	ForgePioHubspotDev: 'forge-connector-RtvzhBL0FFFIjLCBHjXI8QfgDqAs79WF-hubspot-connector',
	ForgePioHubspotProd: 'forge-connector-O19vyTOCxgkZ6KSHycRjpzC0543x6Z0J-hubspot-connector',
	ForgePioSalesforceDev: 'forge-connector-50BYkfgS4GXtr6iO8qUeBFbbHHbuFleo-salesforce-connector',
	ForgePioSalesforceProd: 'forge-connector-nn5lJU1KJxJsUNML5GWV3blDYHMT6nAb-salesforce-connector',
	ForgePioSharepointDev: 'forge-connector-cl5i3J8L463hTuQiDt7f1mK4vZllsAo0-sharepoint-connector',
	ForgePioSharepointProd: 'forge-connector-7yrzYPlAOcZAif2tIymeDXBUNUAxI95G-sharepoint-connector',
	ForgePioStackOverflowDev:
		'forge-connector-ojk0u9oXGmVmS3BC7VmVSBPPIuuF5df3-stack-overflow-connector',
	ForgePioStackOverflowProd:
		'forge-connector-vUmPXguTcgLzdG1R3H0kTUQwxoGnZcsS-stack-overflow-connector',
	ForgeUtoolityGitbookDev: 'forge-connector-FEJ0dhTb8HC3UYmqhPAKYCWVTcpoHsp5-gitbook-connector',
	ForgeUtoolityGitbookProd: 'forge-connector-byNN1wfDuTnx7VndySG7Qq3ZfoXudUcL-gitbook-connector',
	ForgeGdriveEugeneTestDev: 'forge-connector-s7M8FnmJVPQh9FtRqvqwSL3QFtqMijua-gdrive',
	ForgeGdriveEugeneTestProd: 'forge-connector-bkRlqLiPfviKrVtbA6Q0QGN22x6b37mf-gdrive',
	ForgeUnitoSalesforceDev: 'forge-connector-h8rZu86YJHRfyVlmVeUR464Kuhz9OZvV-salesforce',
	ForgeUnitoSalesforceProd: 'forge-connector-qjk3Z8Kt2DWx29hdZHQapEYXAGCPIyd8-salesforce',
	ForgeUnitoServicenowDev: 'forge-connector-52qcnF9TIgxkDKY4OL7xNxAzcM0amb7q-servicenow',
	ForgeUnitoServicenowProd: 'forge-connector-RzFogW4EQLcXYmYpKkItRUhLAn3jETMq-servicenow',
	ForgeUnitoWrikeDev: 'forge-connector-gw0rFhQkj7PuTllmYdHbMaPw6jC18YvO-wrike',
	ForgeUnitoWrikeProd: 'forge-connector-390XhSnH4YgwqVgmyqYOujxVoL3IOUcM-wrike',
	ForgeUnitoAsanaDev: 'forge-connector-6wHDDwNbam77WvGwMKYMGDiTWP8pza54-asana',
	ForgeUnitoAsanaProd: 'forge-connector-sFXfxz3XEDS1wAWWCe345UVrSbUm9zyb-asana',
	ForgeUnitoBasecampDev: 'forge-connector-nImlCTNLZUCtQzFsthpnlYJL0B981lMH-basecamp',
	ForgeUnitoBasecampProd: 'forge-connector-TZqLHQtzvKxRikkh1KQlp4acwCzS5W1Z-basecamp',
	// New 3P? Add it here
} as const;

export type ProductKeys3P = (typeof ProductKeys3P)[keyof typeof ProductKeys3P];

/**
 * Resource types for third-party connectors.
 * Each key maps to the resourceType used in the 3P config endpoint.
 * Connectors without a resourceType (e.g., Loom) are excluded.
 */
export const ProductResourceTypes3P = {
	AtlassianWebCrawler: 'webcrawler-connector',
	Figma: 'figma-connector',
	Github: 'github-connector',
	GoogleDrive: 'google-drive-connector',
	OneDrive: 'onedrive-connector',
	Dropbox: 'dropbox-connector',
	Slack: 'slack-connector',
	Sharepoint: 'sharepoint-connector',
	Teams: 'microsoft-teams-connector',
	GoogleCalendar: 'google-calendar-connector',
	OutlookCalendar: 'outlook-calendar-connector',
	OutlookMail: 'outlook-mail-connector',
	Gmail: 'gmail-connector',
	AdobeSign: 'adobe-sign-connector',
	Asana: 'asana-connector',
	Zendesk: 'zendesk-connector',
	Airtable: 'airtable-connector',
	Smartsheet: 'smartsheet-connector',
	Notion: 'notion-connector',
	Miro: 'miro-connector',
	Docusign: 'docusign-connector',
	Lucid: 'lucid-connector',
	Monday: 'monday-connector',
	AzureDevops: 'azure-devops-connector',
	Gitlab: 'gitlab-connector',
	ConfluenceDC: 'confluence-dc-connector',
	JiraDC: 'jira-dc-connector',
	JsmDC: 'jsm-dc-connector',
	Canva: 'canva-connector',
	Box: 'box-connector',
	Zeplin: 'smartlinks-connector-zeplin',
	ServiceNow: 'servicenow-connector',
	Freshservice: 'freshservice-connector',
	PowerBI: 'smartlinks-connector-power-bi',
	ClickUp: 'smartlinks-connector-clickup',
	Amplitude: 'smartlinks-connector-amplitude',
	Stripe: 'smartlinks-connector-stripe',
	AdobeXD: 'smartlinks-connector-adobexd',
	Aha: 'aha-connector',
	Mural: 'smartlinks-connector-mural',
	Webex: 'smartlinks-connector-webex',
	Todoist: 'smartlinks-connector-todoist',
	PagerDuty: 'smartlinks-connector-pagerduty',
	Pipedrive: 'smartlinks-connector-pipedrive',
	Hubspot: 'hubspot-connector',
	Dovetail: 'smartlinks-connector-dovetail',
	LaunchDarkly: 'smartlinks-connector-launchdarkly',
	Salesforce: 'salesforce-connector',
	Sentry: 'smartlinks-connector-sentry',
	Gitbook: 'gitbook-connector',
	AWSS3: 'aws-s3-connector',
	Databricks: 'databricks-connector',
	ForgeAdamVitareqDev: 'forge-connector-dAkghOClvWGokDftTTaIgNoD6pnNt74z-vitareq-connector',
	ForgeAdamVitareqProd: 'forge-connector-EjfoGWrWrETl3Zc5zkGynPyESZO5Qu93-vitareq-connector',
	ForgeK15tScrollSitesDev:
		'forge-connector-h1n3NRFAn84v7ECSONVidlCS88qZh8cy-scroll-sites-connector',
	ForgeK15tScrollSitesProd:
		'forge-connector-ofe9zXccOCQ3U4t4kDVywSyJUoZjb1sO-scroll-sites-connector',
	ForgePioAwsDev: 'forge-connector-HaxJprV0zzjjvwLhGkAN2gDPhHZwXNiL-s3-connector',
	ForgePioAwsProd: 'forge-connector-mRcqWRwqkUd4JwapGkvGHUViyySX9MVy-s3-connector',
	ForgePioClickupDev: 'forge-connector-ELuz3hTMhig0Jdrr6ytI45SifO9DfKrY-clickup-connector',
	ForgePioClickupProd: 'forge-connector-uwYqtNjM6w0QIhHOFG0Cq4cnkUM9mt3K-clickup-connector',
	ForgePioGitbookDev: 'forge-connector-Xh70v2yqkzOjTQqTMLxk1lElehWIXoYi-gitbook-connector',
	ForgePioGitbookProd: 'forge-connector-cQ1IDSmJT0DrQuF8pGa4ijz0XZ6IGF5u-gitbook-connector',
	ForgePioGithubDev: 'forge-connector-3QYYBgeNDilQB3Jc7uGMCchNgUGvCi7j-github-connector',
	ForgePioGithubProd: 'forge-connector-0Sw5Yr860fgfx5sYS7kEUoxnGhEvrhhI-github-connector',
	ForgePioGitlabDev: 'forge-connector-psr1wBkasRuKCwsvwi4aTJNhjmlVFebC-gitlab-connector',
	ForgePioGitlabProd: 'forge-connector-QLK5Xf8nBqejSZTulw5s3Cl6fIS24MwL-gitlab-connector',
	ForgePioGoogleDriveDev: 'forge-connector-JhqjCcAP6AHHxkYhY2akTgZsYXY93SMq-google-drive-connector',
	ForgePioGoogleDriveProd:
		'forge-connector-pcIwW04B398CSnilRIyzPJ5v5GevlCCo-google-drive-connector',
	ForgePioGuruDev: 'forge-connector-NtY3W5Z8JTBshAgPZFIfT7VjYAARj1P5-guru-connector',
	ForgePioGuruProd: 'forge-connector-mulxOVrXWOZObhFZH5WAqs7Ga2lCPK29-guru-connector',
	ForgePioHelpjuiceDev: 'forge-connector-f1rvRuAyoDWIwDs7Xubi5AZJTuESM5PC-helpjuice-connector',
	ForgePioHelpjuiceProd: 'forge-connector-8durapLyclxZeEexKkwxw6ZpCRpBz4dP-helpjuice-connector',
	ForgePioHubspotDev: 'forge-connector-RtvzhBL0FFFIjLCBHjXI8QfgDqAs79WF-hubspot-connector',
	ForgePioHubspotProd: 'forge-connector-O19vyTOCxgkZ6KSHycRjpzC0543x6Z0J-hubspot-connector',
	ForgePioSalesforceDev: 'forge-connector-50BYkfgS4GXtr6iO8qUeBFbbHHbuFleo-salesforce-connector',
	ForgePioSalesforceProd: 'forge-connector-nn5lJU1KJxJsUNML5GWV3blDYHMT6nAb-salesforce-connector',
	ForgePioSharepointDev: 'forge-connector-cl5i3J8L463hTuQiDt7f1mK4vZllsAo0-sharepoint-connector',
	ForgePioSharepointProd: 'forge-connector-7yrzYPlAOcZAif2tIymeDXBUNUAxI95G-sharepoint-connector',
	ForgePioStackOverflowDev:
		'forge-connector-ojk0u9oXGmVmS3BC7VmVSBPPIuuF5df3-stack-overflow-connector',
	ForgePioStackOverflowProd:
		'forge-connector-vUmPXguTcgLzdG1R3H0kTUQwxoGnZcsS-stack-overflow-connector',
	ForgeUtoolityGitbookDev: 'forge-connector-FEJ0dhTb8HC3UYmqhPAKYCWVTcpoHsp5-gitbook-connector',
	ForgeUtoolityGitbookProd: 'forge-connector-byNN1wfDuTnx7VndySG7Qq3ZfoXudUcL-gitbook-connector',
	ForgeGdriveEugeneTestDev: 'forge-connector-s7M8FnmJVPQh9FtRqvqwSL3QFtqMijua-gdrive',
	ForgeGdriveEugeneTestProd: 'forge-connector-bkRlqLiPfviKrVtbA6Q0QGN22x6b37mf-gdrive',
	ForgeUnitoSalesforceDev: 'forge-connector-h8rZu86YJHRfyVlmVeUR464Kuhz9OZvV-salesforce',
	ForgeUnitoSalesforceProd: 'forge-connector-qjk3Z8Kt2DWx29hdZHQapEYXAGCPIyd8-salesforce',
	ForgeUnitoServicenowDev: 'forge-connector-52qcnF9TIgxkDKY4OL7xNxAzcM0amb7q-servicenow',
	ForgeUnitoServicenowProd: 'forge-connector-RzFogW4EQLcXYmYpKkItRUhLAn3jETMq-servicenow',
	ForgeUnitoWrikeDev: 'forge-connector-gw0rFhQkj7PuTllmYdHbMaPw6jC18YvO-wrike',
	ForgeUnitoWrikeProd: 'forge-connector-390XhSnH4YgwqVgmyqYOujxVoL3IOUcM-wrike',
	ForgeUnitoAsanaDev: 'forge-connector-6wHDDwNbam77WvGwMKYMGDiTWP8pza54-asana',
	ForgeUnitoAsanaProd: 'forge-connector-sFXfxz3XEDS1wAWWCe345UVrSbUm9zyb-asana',
	ForgeUnitoBasecampDev: 'forge-connector-nImlCTNLZUCtQzFsthpnlYJL0B981lMH-basecamp',
	ForgeUnitoBasecampProd: 'forge-connector-TZqLHQtzvKxRikkh1KQlp4acwCzS5W1Z-basecamp',
	// New 3P? Add it here
} as const;

export type ProductResourceTypes3P =
	(typeof ProductResourceTypes3P)[keyof typeof ProductResourceTypes3P];
